import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarehouses = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M9.66 2.572 3.49 5.316c-.603.267-.99.864-.99 1.523v8.994c0 .922.745 1.667 1.667 1.667H5V10c0-.92.745-1.667 1.667-1.667h6.666C14.255 8.333 15 9.08 15 10v7.5h.833c.922 0 1.667-.745 1.667-1.667V6.839c0-.66-.387-1.256-.99-1.523l-6.17-2.744a.84.84 0 0 0-.68 0Z",
		fill: "var(--main-color)"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M13.333 10H6.667v7.5h2.5v-1.25c0-.23.186-.417.416-.417h.834c.23 0 .416.187.416.417v1.25h2.5V10Z",
		fill: "var(--main-color)"
	})]
});
export { SvgWarehouses as ReactComponent };
